import React from 'react';
import AgentScanners from '~/components/AgentScanners';
import NavigationSidebar from '~/components/NavigationSidebar';
import BaseLayout from '~/layouts/BaseLayout';

class AgentScannersLayout extends BaseLayout {
  renderSidebar() {
    return <NavigationSidebar />;
  }

  renderMain() {
    const { route } = this.props;

    return <AgentScanners route={route} />;
  }
}

export default AgentScannersLayout;
